import Vue from 'vue'
import {
  ConfigProvider,
	Button,
	Layout,
	FormModel,
	Input,
	Icon,
	Tabs,
	Modal,
	message,
	Cascader,
  DatePicker,
  TimePicker,
	Checkbox,
  Upload,
  Select,
  Tooltip,
  Table,
  Radio,
  AutoComplete,
  Alert,
  Timeline,
  Dropdown,
  Menu,
  Popconfirm,
  Spin,
  Popover,
  Empty,
  BackTop,
  Progress,
} from 'ant-design-vue'

Vue.use(ConfigProvider)
Vue.use(Button)
Vue.use(Layout)
Vue.use(Layout.Header)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(Modal)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(Radio)
Vue.use(AutoComplete)
Vue.use(Alert)
Vue.use(Timeline)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Popconfirm)
Vue.use(Spin)
Vue.use(Empty)
Vue.use(BackTop)
Vue.use(Progress)
Vue.use(Popover)

message.config({
  top: '10vh',
})

Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info